'use strict';

export function init() {
  const sections = document.querySelectorAll('.orchestra-roster__featured-section, .orchestra-roster__group');
  const navList = document.querySelector('.orchestra-sticky-bar__list');
  const navLinks = document.querySelectorAll('.orchestra-sticky-bar__link');
  const links = [];
  let isScrolling = false;
  let scrollTimeout = null;

  if (navList) {
    navLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          links.push(link);
        }
      }
    });

    const observerOptions = {
      root: null,
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    };

    const observerCallback = entries => {
      // Don't update active state during click scrolling
      if (isScrolling) return;

      entries.forEach(entry => {
        const sectionId = entry.target.id;
        const navLink = document.querySelector(`.orchestra-sticky-bar__link[href="#${sectionId}"]`);

        if (entry.isIntersecting && navLink) {
          links.forEach(link => link.classList.remove('active'));
          navLink.classList.add('active');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => observer.observe(section));

    // Handle click navigation
    if (navList) {
      navList.addEventListener('click', function(e) {
        if (e.target && e.target.tagName === 'A') {
          e.preventDefault();

          const targetHref = e.target.getAttribute('href');
          const targetSection = document.querySelector(targetHref);

          if (!targetSection) return;

          // Set scrolling flag
          isScrolling = true;

          // Immediately update active state
          links.forEach(link => link.classList.remove('active'));
          e.target.classList.add('active');

          // Calculate scroll position
          const orchestraStickyBar = document.querySelector('.orchestra-sticky-bar');
          const orchestraNavigation = document.querySelector('.orchestra-roster__navigation--inner');
          const stickyBarHeight = orchestraStickyBar ? orchestraStickyBar.offsetHeight : 0;
          const navigationHeight = orchestraNavigation ? orchestraNavigation.offsetHeight : 0;

          const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - stickyBarHeight - navigationHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          // Clear previous timeout
          if (scrollTimeout) {
            clearTimeout(scrollTimeout);
          }

          // Re-enable observer after scrolling completes
          scrollTimeout = setTimeout(() => {
            isScrolling = false;
          }, 1000);
        }
      });
    }
  }
}
